import { MemberAutogiroStatusRequest } from 'src/modules/member/models/memberAutogiroStatusRequest';
import { MemberAutogiroStatus } from 'src/modules/invoice/models/memberAutogiroStatus';
import { MemberAutogiroStatusResponse } from 'src/modules/member/models/memberAutogiroStatusResponse';
import AxiosInstance from './axios/interceptor';
import { PagedResult } from '../models/pagedResult';

const controller = 'MemberAutogiroStatus';

export const getAllMemberAutogiroStatus = (searchFilter: MemberAutogiroStatus) => {
  return AxiosInstance.get<PagedResult<MemberAutogiroStatusResponse>>(controller, { params: searchFilter });
};

export const createMemberAutogiroStatus = (data: MemberAutogiroStatusRequest) => {
  const endpoint = `${controller}`;
  return AxiosInstance.post<MemberAutogiroStatusRequest>(endpoint, data);
};

export const getActionRequiredCount = () => {
  const endpoint = `${controller}/counts/actionrequired`;
  return AxiosInstance.get<number>(endpoint);
};

// deleteMandate raderar även själva medgivandet, vilket är det rimliga när det inte går att
// använda. API:et gör båda stegen i samma anrop och nollställer kopplingen på medlemmen.
export const deleteMemberAutogiroStatus = (autogiroStatusId: number, deleteMandate = false) => {
  const endpoint = `${controller}/${autogiroStatusId}${deleteMandate ? '?deleteMandate=true' : ''}`;
  return AxiosInstance.delete(endpoint);
};
